import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductDetailsWarehouseStockDto, ProductDto, ProductServiceProxy } from '@shared/service-proxies/service-proxies';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'kt-detail-modal',
  templateUrl: './detail-modal.component.html',
  styleUrls: ['./detail-modal.component.scss']
})
export class DetailModalComponent implements OnInit {

  readonly TAB1 : string = 'prod-detail-tab1';
  readonly TAB2 : string = 'prod-detail-tab2';

  numberTabByUsers = new BehaviorSubject<string>(this.TAB1);
  tabTitle : BehaviorSubject<string> = new BehaviorSubject<string>("Ürün Ölçüleri");
  productId : number ;
  product$ : BehaviorSubject<ProductDto> = new BehaviorSubject<ProductDto>(null);
  productStock$ : BehaviorSubject<ProductDetailsWarehouseStockDto[]> = new BehaviorSubject<ProductDetailsWarehouseStockDto[]>(null);

  

  constructor(
    private _route: ActivatedRoute,
    private _productService : ProductServiceProxy,
    private _modalService: NgbModal,
    @Inject(MAT_DIALOG_DATA)
    public _data: any
  ) { 

    this.productId = this._data.productId ;

  }

  ngOnInit() {
      this._productService.getProductInfo(this.productId)
            .subscribe(res => {
              this.product$.next(res);
            });
  }

  /**
   * Detaylari gosterilen urunun, kullanicinin gormye yetkili oldugu tum depolardaki stok miktarlarini alir.
   */
  loadProductStock(){

    //Stoklar daha once cekilmis ise, tekrar cekilmez. 
    if (this.productStock$.value) return ;

    this._productService.getProductStockInWarehouses(this.productId)
            .subscribe(res => {
              this.productStock$.next(res);
            });
  }

  changeTab(tabName: string){
      this.numberTabByUsers.next(tabName);

      if (tabName == this.TAB1){
        this.tabTitle.next("Ürün Ölçüleri");
      }
      else if (tabName == this.TAB2){
        this.tabTitle.next("Stoklar");

        this.loadProductStock();
        
      }
  }

}
